import { MutationTree }       from 'vuex';
import { State, XAxisReport } from '@/views/x-axis-report/report-list/store/x-axis-report-list.state.store';

const mutations: MutationTree<State> = {
  setDataLoaded(state, loading: boolean): void {
    state.loading = loading;
  },
  setReportList(state, payload: XAxisReport[]): void {
    state.reportList = payload;
  },
};

export default mutations;
